import { createIcon } from '../createIcon.tsx';

export const ArrowDownIcon = createIcon(
	'ArrowDownIcon',
	<>
		<line x1="12" y1="4" x2="12" y2="20" />
		<polyline points="6 14 12 20 18 14" />
	</>,
);
